import axios from 'axios'

export function login (data) {
    return axios.post(`/auth/login`,data)
}
export function loginOut () {
    return axios.get(`/auth/logout`)
}